<template>
  <Page class="page" :filters="filters">
    <div class="title">{{ $t('report.exportIntroduction') }}</div>
    <div class="subtitle">{{ $t('report.collaboratorSource') }}</div>
    <div class="content">
      <div class="map" :style="{ backgroundImage: `url(${mapUrl})` }"></div>
      <div class="site-container">
        <div class="site">
          <div class="marker small"></div>
          <div class="site-info">
            <div class="site-name">{{ $t('pointCollaborators.10') }}</div>
          </div>
        </div>
        <div class="site">
          <div class="marker">10+</div>
          <div class="site-info">
            <div class="site-name">{{ $t('pointCollaborators.30') }}</div>
          </div>
        </div>
        <div class="site">
          <div class="marker">30+</div>
          <div class="site-info">
            <div class="site-name">{{ $t('pointCollaborators.60') }}</div>
          </div>
        </div>
        <div class="site">
          <div class="marker">60+</div>
          <div class="site-info">
            <div class="site-name">{{ $t('pointCollaborators.99') }}</div>
          </div>
        </div>
        <div class="site">
          <div class="marker">99+</div>
          <div class="site-info">
            <div class="site-name">{{ $t('pointCollaborators.100') }}</div>
          </div>
        </div>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Report/BasePage';

export default {
  name: 'IntroductionCollaboratorPage',

  components: {
    Page,
  },

  props: {
    study: {
      type: Object,
      required: false,
      default: () => ({}),
    },

    export: {
      type: Object,
      required: false,
      default: () => ({}),
    },

    filters: {
      type: String,
      required: false,
      default: null,
    },

    disableCount: {
      type: [Boolean, Number],
      required: false,
      default: false,
    },

    filterCollaborators: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  data() {
    return {
      mapUrl: null,
    };
  },

  watch: {
    filterCollaborators() {
      this.$store.dispatch('getExportSiteMapCollaborator', { id: this.export.public_id }).then(response => {
        this.mapUrl = response.url;
      });
    },
  },

  created() {
    this.$store.dispatch('getExportSiteMapCollaborator', { id: this.export.public_id }).then(response => {
      this.mapUrl = response.url;
    });
  },
};
</script>

<style scoped lang="scss">
@use 'sass:color';
@use '@/styles/colors.scss';

.page {
  padding: 48px 80px;
  box-sizing: border-box;

  .title {
    display: flex;
    flex-direction: column;
    font-size: 32px;
    font-weight: 600;
    color: #3c3c3b;
    margin-bottom: 16px;

    &::after {
      content: '';
      margin: 8px 0;
      width: 64px;
      height: 4px;
      border-radius: 4px;
      background: colors.$main-color;
    }
  }

  .subtitle {
    display: flex;
    flex-direction: column;
    font-size: 24px;
    font-weight: 200;
    color: #3c3c3b;
    margin-bottom: 16px;
  }

  .content {
    display: flex;

    .map {
      flex-shrink: 0;
      width: 480px;
      height: 480px;
      background: colors.$grey-color;
      border-radius: 4px;
      pointer-events: none;
      box-shadow: 0 8px 16px -4px rgba(0, 0, 0, 0.2);

      background-size: cover;
      background-position: center;
    }

    .site-container {
      margin-left: 24px;
      height: 100%;

      .site {
        display: flex;
        margin: 0 0 8px;
        align-items: center;

        .marker {
          flex-shrink: 0;
          margin: 0 12px 0 0;
          width: 32px;
          height: 32px;
          border: solid 2px color.mix(colors.$warning-color, colors.$white-color, 65%);

          background: colors.$warning-color;
          color: colors.$white-color;
          border-radius: 32px;
          text-align: center;
          line-height: 32px;
          box-shadow:
            2px 4px 12px -2px rgba(0, 0, 0, 0.1),
            0 0 8px -4px rgba(colors.$warning-color, 0.2);

          &.small {
            margin: 8px 20px 8px 8px;
            width: 16px;
            height: 16px;
          }
        }

        .site-info {
          font-size: 14px;

          .site-name {
            color: #0f0f0f;
            font-weight: bold;
            font-size: 13px;
          }
          .site-address {
            color: #3c3c3b;
          }
        }
      }
    }
  }
}
</style>
